import './Historiques.css'
import {Button, Card} from "react-bootstrap";
import React, {useEffect} from "react";
import {AnswersDoughnutChart, ModuleProgress, ProgressionLineChart, WeekPerWeekLineGraph} from "./Graphs/Graphs";
import clsx from "clsx";
import {IconButton} from "@mui/material";
import {ChevronRight} from "@mui/icons-material";
import {ProgressBar} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {BarChartLoader, PieChartLoader, StatsLoader, WeekStrongPointsButtonsLoaders} from "./Loaders/Loaders";
import {ModulesCardsLoader} from "./Loaders/Loaders";
import {deactivateLoading} from "../../redux/actions/actions";

export default function GeneralHistoriques(){
    const generalHistoriques = useSelector(state=>state.generalHistoriques);
    const dispatch=useDispatch();
    useEffect(()=>{
        setTimeout(()=>{
            dispatch(deactivateLoading())
        }, 10000)
    },[])
    const WeekStatsCard=({label , value ,borderBottom , borderLeft , borderRight , borderTop , loading})=>{
        if(loading){
            return (
                <StatsLoader/>
            )
        }
        return (
            <div className={clsx("d-flex flex-column col-6 text-align-center text-align-center-lg pt-2 pb-2" , {borderTopWeekStatsCard : borderTop , borderBottomWeekStatsCard : borderBottom , borderRightWeekStatsCard :borderRight , borderLeftWeekStatsCard : borderLeft})}>
                <div style={{fontSize : '2.7rem' , color : 'var(--info)'}}>{value}</div>
                <div className="mt-2 mb-2" style={{fontSize : '1rem' , color : 'gray'}}>{label}</div>
            </div>
        )
    }
    return (
            <div>
                <div className="row">
                    <div className="col-lg-8 col-12">
                        <div className="profile card card-body p-3 h-100">
                            <div className={clsx("media align-items-center p-3 mb-md-4 mb-3", {'d-flex justify-content-center' : generalHistoriques.loading})}>
                                { generalHistoriques.loading ? <BarChartLoader/>  :<WeekPerWeekLineGraph/> }
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-12 align-self-lg-center" >
                        <div className="profile card card-body p-3">
                            <div  className="p-2 d-flex flex-column justify-content-center mt-3 mb-3 mt-lg-0 mb-lg-0">
                                <div style={{ color : 'gray' , fontSize : '1.2rem'}} className="w-100 text-align-center text-align-center-lg mt-2 mb-2">Vos stats de la semaine</div>
                                <div className="d-flex flex-column justify-content-center">
                                    <div className={clsx("d-flex flex-row" , { 'w-100 justify-content-center' : generalHistoriques.loading } )} >
                                        <WeekStatsCard loading={generalHistoriques.loading} borderBottom borderRight value={1242} label={'QUESTIONS'} />
                                        <WeekStatsCard loading={generalHistoriques.loading} borderBottom borderLeft value={'71%'} label={'JUSTES'} />
                                    </div>
                                    <div className={clsx("d-flex flex-row" , { 'w-100 justify-content-center' : generalHistoriques.loading } )}>
                                        <WeekStatsCard loading={generalHistoriques.loading} borderTop borderRight value={1242} label={'QUESTIONS'} />
                                        <WeekStatsCard loading={generalHistoriques.loading} borderTop borderLeft value={'71%'} label={'JUSTES'} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="row mt-3">
                    <div className="col-lg-4 col-12">
                        <div className="profile card card-body p-3 h-100 secondLineHistoriques">
                            <div className="p-2">
                                {  !generalHistoriques.loading ? <AnswersDoughnutChart/> : <PieChartLoader/> }

                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-12">
                        <div className="profile card card-body p-3 h-100 secondLineHistoriques">
                            <div  className={ clsx("p-2" , {"d-flex justify-content-center align-items-start": generalHistoriques.loading } )}>
                                { !generalHistoriques.loading ? <ProgressionLineChart/> : <BarChartLoader/> }
                            </div>
                        </div>
                    </div>
                    <div  className="col-lg-4 col-12">
                        <div className="p-3 profile card card-body secondLineHistoriques">
                            <div  className="p-2 d-flex flex-column justify-content-lg-around h-100">
                                <div style={{backgroundColor : '#fff'}} className="btn d-flex pt-4 pb-4 mb-lg-0 mb-2 border border-success rounded "  variant="outline-primary btn-square">
                                    <div className="w-100">
                                        {generalHistoriques.loading ? <WeekStrongPointsButtonsLoaders/> :
                                            <React.Fragment>
                                                <div
                                                    style={{fontSize: '1.8rem', color: 'var(--success)'}}>Dermatologie
                                                </div>
                                                <div style={{color: 'gray'}}>VOTRE POINT FORT</div>
                                            </React.Fragment>
                                        }

                                    </div>
                                    {
                                        generalHistoriques.loading ? null :
                                            <div className="align-self-lg-center">
                                                <IconButton aria-label="delete" size="large">
                                                    <ChevronRight style={{color : 'var(--info)' , fontSize : '2rem'}} />
                                                </IconButton>
                                            </div>
                                    }

                                </div>
                                <div  style={{backgroundColor : '#fff'}}   className="btn d-flex pt-4 pb-4 mb-lg-0 mb-2 border border-danger rounded " variant="outline-danger btn-square">
                                    <div className="w-100">
                                        { generalHistoriques.loading ? <WeekStrongPointsButtonsLoaders/> :
                                            <React.Fragment>
                                                <div style={{fontSize : '1.8rem' , color : 'var(--danger)generalHistoriques'}}>Anatomie</div>
                                                <div style={{color: 'gray'}}>VOTRE POINT FAIBLE</div>
                                            </React.Fragment>
                                        }

                                    </div>
                                    {
                                        generalHistoriques.loading ? null  :
                                            <div className="align-self-lg-center">
                                                <IconButton aria-label="delete" size="large">
                                                    <ChevronRight style={{color : 'var(--info)' , fontSize : '2rem'}} />
                                                </IconButton>
                                            </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5 pb-lg-4">
                    <div style={{borderBottom : '1px solid #eee'}} className="d-flex flex-lg-row flex-column justify-content-lg-between mb-4">
                        <div className="mb-2 mb-lg-0" style={{color : 'var(--info)'}}>Analyses par module</div>
                        <div className="mb-2 mb-lg-0" style={{color : 'gray' , fontSize : '0.8rem'}}>Cliquez sur un module pour plus de détails</div>
                    </div>
                    <div className="row">
                        { generalHistoriques.loading ? <ModulesCardsLoader/> :
                            <React.Fragment>
                                <ModuleProgress/>
                                <ModuleProgress/>
                                <ModuleProgress/>
                                <ModuleProgress/>
                                <ModuleProgress/>
                            </React.Fragment>
                        }

                    </div>
                </div>
            </div>
        )

}
